<template>
	<div class="test_result_structure">
		<pre class="doc_main_pre"><code class="doc_main_code">//JSON格式返回值
{
    "error_code":"0",
    "error_msg":"OK",
    "tags":[
         {
            "tag_name":"运动鞋",
            "tag_confidence":81
        },
        {
            "tag_name":"跑鞋",
            "tag_confidence":18
        }
    ]
}
{
    "error_code":"0",
    "error_msg":"OK",
    "image_id":"1",
    "tags":[
         {
            "tag_name":"运动鞋",
            "tag_confidence":81
        },
        {
            "tag_name":"跑鞋",
            "tag_confidence":18
        }
    ]
}</code></pre>
	</div>
</template>
<script>
	export default{
		// props: {
  //           pathData:null,
  //       },
		data(){
			return{
				
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){
			
		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../less/index.less';
	.test_result_structure{
		
	}
</style>	


// WEBPACK FOOTER //
// src/components/SKEyeJson.vue